import CONFIG from '../config.js';

const handleResponse = (response) => {
  if (!response) {
    return null;
  }
  // Handle legacy DynamoDB response format for backward compatibility
  if (response.Item) {
    return response.Item;
  }
  if (response.Items) {
    return response.Items;
  }
  return response;
};

// Session-based fetch helper (no Amplify/Cognito)
export default async (type, url, params = null, body = null) => {
  const options = {
    method: type.toUpperCase(),
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include', // Include session cookies
  };

  // Add query string parameters to URL
  let fullUrl = `${CONFIG.API_BASE_URL}/${url}`;
  if (params) {
    const queryString = new URLSearchParams(params).toString();
    fullUrl += `?${queryString}`;
  }

  // Add body for POST/PUT requests
  if (body && (type === 'post' || type === 'put')) {
    options.body = JSON.stringify(body);
  }

  try {
    const response = await fetch(fullUrl, options);

    // Handle error responses
    if (!response.ok) {
      let errorData;
      try {
        errorData = await response.json();
      } catch (parseError) {
        // If response body isn't JSON, use status text
        throw new Error(
          `${response.status}: ${response.statusText || 'Request failed'}`,
        );
      }

      // Extract error message from various possible formats
      const errorMessage =
        errorData.error || // { error: 'message' }
        errorData.message || // { message: 'message' }
        errorData.err?.message || // { err: { message: 'message' } }
        errorData.err || // { err: 'message' }
        response.statusText || // HTTP status text
        'Request failed';

      // Create error with useful properties
      const error = new Error(errorMessage);
      error.status = response.status;
      error.statusText = response.statusText;
      error.data = errorData;
      error.url = fullUrl;

      throw error;
    }

    // Parse successful response
    const data = await response.json();
    return handleResponse(data);
  } catch (error) {
    // Re-throw errors we created above
    if (error.status) {
      throw error;
    }

    // Handle network errors or other fetch failures
    const networkError = new Error(error.message || 'Network request failed');
    networkError.originalError = error;
    networkError.url = fullUrl;

    throw networkError;
  }
};
